import { ApolloProvider as Apollo } from '@apollo/client/react/context/ApolloProvider';
import PropTypes from 'prop-types';
import React from 'react';
import client from '../apollo';

const ApolloProvider = ({ children }) => (
  <Apollo client={client}>{children}</Apollo>
);

ApolloProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ApolloProvider;
